export default __webpack_public_path__ + "static/media/charities-nav.10fcdfc1.svg";